export default "__VITE_ASSET__DhgFE0ku__"